import React from 'react';
import './styles.css';

const LoadingBars = () => {
  return (
    <div className="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default LoadingBars; 